import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, ModalTitle, Text } from '@modusign/design-system';
import { ReactNode } from 'react';

interface UpSellingModalTitleProps {
  children: ReactNode;
  onCloseClicked?: () => void;
}

export default function UpSellingModalTitle({
  children,
  onCloseClicked,
}: UpSellingModalTitleProps) {
  return (
    <Box px={9} width="100%">
      <Box position="relative">
        <ModalTitle mb={4}>{children}</ModalTitle>
        {(onCloseClicked || true) && (
          <Box position="absolute" right="-12px" top="-12px">
            <Text
              color="iconNeutralBase"
              fontSize="24px"
              fontWeight="regular"
              sx={{
                cursor: 'pointer',
              }}
              onClick={onCloseClicked}
            >
              <FontAwesomeIcon icon={faXmark} />
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
}
